export const EARLIEST_APPOINTMENT_AVAILABLE = "Earliest Appointment available :";
export const SELECT_DATE = "Date";
export const SELECT_SERVICE_CENTER = "Service Centre";
export const ARE_YOU_VISITING_US_WITH_ANOTHER_PERSON =
  "Are you visiting us with another person with CPF enquiries?";
export const YOUR_BOOKING_IS_CONFIRMED = "Your booking is confirmed!";
